import * as React from 'react';
import {useNavigate} from 'react-router-dom';
import counsel from "../assets/images/counsel.png";
import Box from '@mui/material/Box';
import Bottom from "./Bottom";
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {styled} from '@mui/material/styles';
import * as util from "../utils/util";
import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AddIcon from '@mui/icons-material/Add';
import checkimg1 from "../assets/images/check.png";
import checkimg2 from "../assets/images/checkimg2.png";
import { selfQuestionnaires } from "../utils/selfQuestionnaires";

const Check = () => {
  // 새로고침 이미지 변경
  const ImageArr = [checkimg1, checkimg2, ];
  const randomImg = Math.floor(Math.random() * ImageArr.length);
  const checkTopImg = ImageArr[randomImg];
  const navigate = useNavigate();


  
  return (
    <Container sx={{ p: '0 !important', bgcolor: '#F6F6F6', pb: '100px !important', minWidth: 320, }}>
      {/* <CareHomeTop /> */}

      <Box sx={{ bgcolor: '#DFF1FF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#DFF1FF'} zIndex={999} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>

        <Grid container spacing={2} direction='row' sx={{ mt: 6 }}>

          <Grid container xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography sx={{ fontSize: '2.2rem', color: '#1359D2', fontWeight: 900, }}>
              건강체크
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#4988F6', fontWeight: 500, }} gutterBottom>
              진단서비스
            </Typography>
          </Grid>
          <Grid sx={{ width: '45%', mr: 1, pt: 0, pl: 0 }} justifyContent='center' alignContent={'center'}>
            <Img alt="care" src={checkTopImg} />
          </Grid>
        </Grid>
      </Box>


      <Box sx={{ pl: 2, pr: 2, mt: 2 }}>
        <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', p: '30px 0 0 0', textAlign: 'center' }}>
          <b>자가진단</b>
        </Typography>
        <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
          {/* <Box sx={{ width: '40%' }}>
            <Img alt="selfcheck" src={selfcheck} />
          </Box> */}
          {/* <Box sx={{ width: '60%', pl: 1 }}>

            <Typography sx={{ display: 'block', fontSize: '14px', color: '#444', }}>
              듀얼헬스케어의 쉽고 간단한 자가진단 테스트로 방문 하시기전 미리 체크해 보세요
            </Typography>
          </Box> */}

          <Box sx={{}}>

            <Typography sx={{ display: 'block', fontSize: '14px', color: '#444', mt: 1,p:1 }}>
              듀얼헬스케어의 쉽고 간단한 자가진단 테스트로 방문 하시기전 미리 체크해 보세요
            </Typography>
          </Box>
        </Stack>
        {/* <Box>
          <Img alt="selfcheck" src={selfcheck} sx={{ width: '70%' }} />
        </Box> */}

        <Stack direction={'row'} spacing={2} sx={{ overflowX: 'auto', whiteSpace: 'nowrap', p: 1, mt: 1, pb: 2 }}>
          {selfQuestionnaires && selfQuestionnaires.sort(() => Math.random() - 0.5).slice(0, 2).map((item, index) => (
            <Box onClick={() => navigate('./SelfStart', {state: {selfQuestionNo: item.no}})} sx={BoxStyle}>
              <Typography sx={BoxTitle}>{item.title}</Typography>
              {/* <Typography sx={BoxText}>{item.desc}</Typography> */}
              <ArrowForwardIcon sx={BoxIcon} />
            </Box>
          ))}

          <Box onClick={() => navigate('./SelfCheckList')} sx={BoxStyle}>
            {/* <Typography sx={BoxTitle}>더보기</Typography> */}
            <Typography sx={BoxTitleMore}>자가진단<br/>테스트<br/>더보기</Typography>
            <AddIcon sx={BoxMoreIcon} />
          </Box>
        </Stack>


        <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', textAlign: 'center', mt: 5 }}>
          <b>상담하기</b>
        </Typography>
        <Box sx={{
            bgcolor: '#fff', p: 1.5, mt: 2, borderRadius: 5,
            boxSizing: 'border-box',
            boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)'
          }}>
        <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2}>
          <Box sx={{ width: '70%', m: '20px auto', borderRadius: 5, boxSizing: 'border-box', }} 
            onClick={() => util.strNull(window.localStorage.userCusID) === '' ? null : navigate('./Counsel')}>
            <Typography sx={{ display: 'block', fontSize: '14px', color: '#444', }}>
              건강관련 문의를 주시면 신속히 답변을 드립니다.
            </Typography>
          </Box>
          <Box sx={{ width: '15%' }}>
            <Img alt="counsel" src={counsel} />
          </Box>
        </Stack>
        {util.strNull(window.localStorage.userCusID) === '' ? (
            <Box sx={{ width: '100%' }}>
              <Button onClick={() => navigate('../Login')} sx={{ textAlign: 'center', width: '100%', fontWeight: 700, pb: 0, pt: 2, color: '#EF8322' }}>
                로그인 하기
              </Button>
            </Box>
          ) : (
            null
          )}
          </Box>
      </Box>


      <Bottom />

    </Container>
  );
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const BoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  bgcolor: '#fff',
  p: 2,
  borderRadius: 5,
  boxSizing: 'border-box',
  boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)'
}

const BoxTitle = {
  fontSize: '14px',
  color: '#444',
  fontWeight: 700,
  flex: 'auto',
  whiteSpace: 'break-spaces',
  width: 105,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkitLineClamp': '3',
  '-webkitBoxOrient': 'vertical',
}

const BoxTitleMore = {
  fontSize: '14px',
  color: '#ef8322',
  fontWeight: 700,
  flex: 'auto',
  whiteSpace: 'break-spaces',
  width: 105,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkitLineClamp': '3',
  '-webkitBoxOrient': 'vertical',
}



const BoxText = {
  fontSize: '12px',
  color: '#444',
  mt: 1,
  whiteSpace: 'break-spaces',
  width: 150,
  flex: 'auto',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkitLineClamp': '3',
  '-webkitBoxOrient': 'vertical',

}

const BoxIcon = {
  ml: 'auto',  
  mt: 2,
  bgcolor: '#ffc08a',
  borderRadius: '50%',
  color: '#fff',
  p:'2px',
  fontSize:20
}

const BoxMoreIcon = {
  ml: 'auto',  
  mt: 2,
  bgcolor: '#f99a48',
  borderRadius: '50%',
  color: '#fff',
  p:'2px',
  fontSize:20
}



const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border: '1px solid #EF8322',
  borderRadius: '25px',
  color: '#EF8322',
  margin: '10px 0 20px 0',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

export default Check;